import { useSelector } from 'src/hooks/useSelector';
import { VacancyFunnelLabel } from 'src/models/vacancyFunnel';

const useIsMultipostFunnel = () => {
    const labels = useSelector((state) => state.vacancyFunnel?.labels) || [];
    return labels.includes(VacancyFunnelLabel.Multipost);
};

export { useIsMultipostFunnel };
